module.exports = __webpack_public_path__ + "img/slide10.7793d6ae.png";